import handleHtmlData from 'utils/global/handleHtmlData'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'

export const yearTemplate = ({
  editorProps,
  templateProps,
  firstInsertion = false,
}) => {
  const { caseDetails, selectedTheme, editor } = editorProps
  const { fieldName } = templateProps

  const templateData = { fieldName }
  const encodedProperties = handleHtmlData.encode(templateData)

  const date = caseDetails[fieldName]

  if (!date) return ''

  const formattedDate = new Date(date)
  const fullYear = formattedDate.getFullYear()
  const yearParagraph = `<p><span class="mceNonEditable">${fullYear}</span></p>`

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor,
    firstInsertion,
  })

  const html = `
    <div data-template="${fieldName}_year" data-properties="${encodedProperties}" class="mceNonEditable" style="${themeStyles}">
      ${yearParagraph}
    </div>
  `

  return html
}

export default yearTemplate
